import React from 'react';
import Footer from '../components/Footer';
import {
  BadgeIndianRupee,
  Car,
  CreditCard,
  FileText,
  IdCard,
  RefreshCcw,
  Shield,
  UserCheck,
  IndianRupee,
} from 'lucide-react';

const drivingLicencePricing = [
  { name: "Learner's Licence", price: 199, icon: IdCard },
  { name: 'Driving Licence (New)', price: 299, icon: UserCheck },
  { name: 'Licence Renewal', price: 199, icon: RefreshCcw },
  { name: "Learner's Licence Renewal", price: 149, icon: FileText },
  { name: 'International Driving Permit', price: 499, icon: CreditCard },
  { name: 'Additional Driving Licence', price: 199, icon: IdCard },
  { name: 'Heavy Vehicle Licence', price: 399, icon: Car },
  { name: 'Heavy Vehicle Licence Renewal', price: 399, icon: RefreshCcw },
];

const vehicleServicesPricing = [
  { name: 'Road Tax Assistance', price: 199, icon: BadgeIndianRupee },
  { name: 'Challan Assistance / Payment Help', price: 99, icon: FileText },
  { name: 'Registration Renewal (Private Vehicles)', price: 299, icon: RefreshCcw },
  { name: 'Certificate of Fitness (Commercial Vehicles)', price: 399, icon: Shield },
  { name: 'Transfer of Ownership (Starting from)', price: 499, icon: FileText },
  { name: 'Hypothecation (Loan Cancellation)', price: 299, icon: CreditCard },
];

const PriceListCard = ({ title, items, accent = 'blue' }) => {
  const accentStyles = {
    blue: 'from-blue-700 via-blue-600 to-cyan-500',
    orange: 'from-orange-500 via-orange-400 to-amber-300',
  };

  return (
    <div className='bg-white dark:bg-gray-800 rounded-2xl border border-blue-100 dark:border-gray-700 shadow-md overflow-hidden'>
      <div className={`bg-gradient-to-r ${accentStyles[accent]} text-white px-5 py-3`}>
        <h3 className='text-xl md:text-2xl font-bold tracking-wide'>{title}</h3>
      </div>
      <div className='divide-y divide-gray-100 dark:divide-gray-700'>
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.name} className='px-5 py-4 flex items-start gap-3 justify-between'>
              <div className='flex items-start gap-3'>
                <div className='bg-blue-50 dark:bg-gray-700 text-blue-600 dark:text-blue-300 rounded-lg p-2 mt-0.5'>
                  <Icon className='w-4 h-4' />
                </div>
                <p className='text-gray-800 dark:text-gray-100 font-medium leading-snug'>{item.name}</p>
              </div>
              <div className='text-orange-500 font-extrabold text-2xl whitespace-nowrap ml-3 flex items-center gap-1'>
                <IndianRupee className='w-4 h-4' />
                <span>{item.price}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const Pricing = () => {
  return (
    <div className='bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 min-h-screen'>
      <section className='bg-gradient-to-r from-[#0b2a78] via-[#0a3ca3] to-[#0e51d8] text-white pt-12 pb-16 px-6 lg:px-8'>
        <div className='max-w-6xl mx-auto text-center'>
          <h1 className='text-4xl md:text-5xl font-bold mb-3'>RTO Bharat Pricing</h1>
          <p className='text-blue-100 text-lg max-w-3xl mx-auto'>
            Transparent assistance charges for key RTO services across India.
          </p>
        </div>
      </section>

      <main className='max-w-6xl mx-auto px-4 sm:px-6 -mt-10 pb-12'>
        <div className='grid lg:grid-cols-2 gap-6'>
          <PriceListCard title='Driving Licence' items={drivingLicencePricing} accent='blue' />
          <div className='space-y-6'>
            <PriceListCard title='Vehicle Services' items={vehicleServicesPricing} accent='orange' />

            <div className='bg-white dark:bg-gray-800 rounded-2xl border border-green-200 dark:border-green-900/50 shadow-md overflow-hidden'>
              <div className='bg-gradient-to-r from-emerald-700 to-green-600 text-white px-5 py-3'>
                <h3 className='text-xl md:text-2xl font-bold tracking-wide'>Insurance</h3>
              </div>
              <div className='px-5 py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3'>
                <div>
                  <p className='text-gray-800 dark:text-gray-100 text-lg font-semibold'>Vehicle Insurance Assistance</p>
                  <p className='text-gray-500 dark:text-gray-300 text-sm'>No service charge (commission-based via insurer)</p>
                </div>
                <p className='text-5xl font-extrabold text-emerald-600'>0</p>
              </div>
            </div>
          </div>
        </div>

        <div className='mt-8 bg-white dark:bg-gray-800 border-l-4 border-orange-500 rounded-xl p-5 shadow-sm'>
          <h4 className='text-xl font-bold text-orange-600 mb-2'>Important Disclaimer</h4>
          <ul className='list-disc pl-5 text-gray-700 dark:text-gray-200 space-y-1'>
            <li>Government fees are charged separately as per Parivahan and State RTO rules.</li>
            <li>RTO Bharat is an independent service provider and does not represent any government authority.</li>
          </ul>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Pricing;
